
export default class TableModel {
    constructor (columns = []) {
        this.columns = columns
    }
}
